import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Oakdale",
  metaDescription: "Local plumber in Oakdale, MN. Bruce Nelson Plumbing & Heating is headquartered in Oakdale, offering fast, reliable plumbing and heating services. Call 651-738-9354.",
  heroTitle: "Plumber in Oakdale, MN",
  heroSubtitle: "Your hometown plumber - headquartered right here in Oakdale since 1976.",
  introduction: "As Oakdale's hometown plumber, Bruce Nelson Plumbing & Heating has been proudly serving our community from our 6th Street North location for nearly 50 years. We know Oakdale inside and out, from the established neighborhoods near Tanners Lake to the newer developments. When you need a plumber you can trust, choose the local experts.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Complete home plumbing services for Oakdale residents, from repairs to installations.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Professional plumbing for Oakdale businesses along I-94 and throughout the city.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Expert boiler installation and repair to keep your Oakdale home comfortable.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Same-day water heater service for Oakdale homeowners.",
      link: "/services/water-heaters"
    },
    {
      title: "Bathroom Remodeling",
      description: "Transform your Oakdale bathroom with our skilled remodeling team.",
      link: "/services/remodeling"
    },
    {
      title: "Air Conditioning",
      description: "Stay cool in summer with our AC installation and repair services.",
      link: "/services/air-conditioning"
    }
  ],
  whyChooseUs: [
    "Headquartered in Oakdale - we're your neighbors!",
    "Fastest response times in Oakdale",
    "Licensed, bonded, and insured since 1976",
    "Know Oakdale homes and plumbing systems inside and out",
    "Transparent pricing with no surprises",
    "Hundreds of happy Oakdale customers"
  ],
  serviceAreas: [
    { name: "Saint Paul", link: "/plumber-saint-paul" },
    { name: "Minneapolis", link: "/plumber-minneapolis" },
    { name: "Woodbury", link: "/plumber-woodbury" },
    { name: "Lake Elmo", link: "/plumber-lake-elmo" },
    { name: "Maplewood", link: "/plumber-maplewood" },
    { name: "Cottage Grove", link: "/plumber-cottage-grove" }
  ],
  testimonial: {
    text: "Being in Oakdale, BNPH is always quick to respond. They've handled everything from small repairs to our complete bathroom remodel. Wouldn't use anyone else!",
    author: "Tom K."
  }
};

const OakdalePage = () => <CityPageTemplate cityData={cityData} />;

export default OakdalePage;
